import React, { Component } from 'react'
import { SelectorCard, NullComp } from './'
import sortByPropText from '../../../helpers/content/manageSets/sortByPropText';
import values from 'mout/object/values';
class ManageStudentsSelectorCard extends Component {
  render() {
    const { user } = this.props
    const role = user ? user.role : ''
    let schs = sortByPropText(values(this.props.schools), 'name')
    let color = '';
    if(schs.length===0)
    {
      color = '#ff9191';
    }
    return (
      <SelectorCard>
        <SelectorCard.Header>Manage Students</SelectorCard.Header>
        <SelectorCard.Instructions>
          Select the school where you want to manage students, then click 'Next' to continue.
        </SelectorCard.Instructions>
        {role === 'Super Administrator'
          ? <SelectorCard.ProgressBar selectorName={'district'} />
          : <NullComp />
        }
        {role === 'Super Administrator'
          ? <SelectorCard.DistrictSelect districts={this.props.districts} />
          : <NullComp />
        }
        <SelectorCard.ProgressBar selectorName={'school'}  color={color}/>
        <SelectorCard.SchoolSelect
          schools={this.props.schools}
          baseLink='/users/manage/students/'
          role={role}
          color={color}
        />
        <SelectorCard.Nav />
      </SelectorCard>
    )
  }
}

export default ManageStudentsSelectorCard


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManageStudentsSelectorCard.js